import { State } from '../../../../../interfaces/merchants/products/purchases';

export const getPurchases = (state: State) => state;
